import axios from "axios";
import { END_POINTS } from "@/config/endPoints";
import { getApiTokenInfo } from "@/authentication/authentication";
import { _setUrl } from "@/utils/http/httpClient";
import { fetchAll, type PagedResponse } from "@/utils/fetchAll";
import { fetchSize } from "@/config/constants";

async function requestCatalogueItems(includeSubCatalogues: boolean, page: any, size: any, catalogueObj: any) {
  const END_POINT = END_POINTS.FILTER_CATALOGUE;
  let requestUrl = _setUrl(END_POINT, "adminServiceApiDomain");
  const token: any = await getApiTokenInfo();
  requestUrl = `${requestUrl}?includeChildren=${includeSubCatalogues}&page=${page}&size=${size}`;
  return axios
    .post(requestUrl, catalogueObj, {
      headers: {
        Authorization: `${token.tokenType} ${token.accessToken}`
      }
    })
    .then((response) => {
      const data = response.data;
      data.content = (data.content ?? []).sort((first: any, second: any) => first.sequence - second.sequence);
      return data;
    })
    .catch((error) => error);
}

export async function filterCatalogueItems(
  catalogueObj: any = {},
  includeSubCatalogues = false,
  onFirstPage?: (firstResponse: PagedResponse) => void,
  size: number = fetchSize.catalogue
) {
  const response = await fetchAll(
    (page, pageSize) => requestCatalogueItems(includeSubCatalogues, page, pageSize, catalogueObj),
    size,
    onFirstPage
  );
  if (Array.isArray(response?.content)) {
    response.content = [...response.content].sort((first: any, second: any) => first.sequence - second.sequence);
  }
  return response;
}
